import  PageStyle from "@/styles/components/cv-library/_index.module.scss";
import { Button, ErrorPages, Form, Formik, FormikControl, handleCvLibrarySubmit, InputError,
  cvLibraryValidations, useRouter, useState} from "@/imports-files/pages/clients/activities/client-integrations";

export function CvLibrary(props) {
  const router = useRouter();
  const [apiError, setApiError] = useState(null);
  const errorPages  =   new ErrorPages();
  const initialValues = {
    username: '',
    password: ''
  }


  if(errorPages.handleErrorCodes(apiError?.status))
  {
    var renderPage  =  apiError ? errorPages.renderPage(apiError?.status, router) : null;
    return renderPage; 
  } 

  return props.trigger ? (
    <div className={`${PageStyle.Modalpopup}`}>
      <div className={`${PageStyle.CvModal}`} >      
      <div className={PageStyle.OtpBacksection2}>
          <div className={PageStyle.Otpback}>
            <Button
              buttonstyle={PageStyle.nobgbutton}
              type="button"
              onClick={()=> props.setCvLibraryModal(false)}
            >
              Close
            </Button>
          </div>
        </div>
        <div className={PageStyle.Logincontent}>
          <div className={PageStyle.Logincontent__title}>
            <h1>CV Library</h1>
          </div>

          <div className={PageStyle.Form}>
                          <Formik
                            initialValues={initialValues}
                            validationSchema={cvLibraryValidations}
                            onSubmit={ (values) =>  handleCvLibrarySubmit(values, props.row, router, props.setCvLibraryModal, setApiError) }>
                            {(formik) => (
                              <Form>

                                <div className={PageStyle.Form__container}>
                                  <div className={PageStyle.Form__Container}>
                                    <FormikControl
                                      control="input"
                                      formik = {formik}
                                      type="text"
                                      name="username"
                                      placeholder= "Username"
                                      className={`width100 ${PageStyle.Form__Input}`}
                                      errorClass={PageStyle.Form__error}
                                      style={InputError(formik, "username")}
                                    />
                                  </div>

                                  <div className={PageStyle.Form__Container}>
                                    <FormikControl
                                      control="input"
                                      formik = {formik}
                                      type="password"
                                      name="password"
                                      placeholder="Password"
                                      className={`width100 ${PageStyle.Form__Input}`}
                                      errorClass={PageStyle.Form__error}
                                      style={InputError(formik, 'password')}
                                    />
                                  </div>
                                  <Button buttonstyle={PageStyle.primarybtn} type="submit" >Submit</Button>

                                  <Button buttonstyle={PageStyle.secondarybtnborder} type="button" onClick={()=> props.setCvLibraryModal(false)} >Cancel</Button>

                                </div>

         
                              </Form>
                            )}
                          </Formik>

                        </div>
        </div>
        </div>
    </div>
  )
  : 
  ""
}
